import React from "react";
import Media from "../shared/Media";
import { getMediaUrl } from "../../lib/utils";

const Voice = ({ url }) => {
  return <Media media={getMediaUrl(url)} />;
};

export default Voice;